import { Button, Result } from 'ui';
import { useLogout } from 'common/services/hooks';

type P = {
  subTitle: string;
};

const FetchUserError = ({ subTitle }: P) => {
  const onLogout = useLogout();

  return (
    <Result
      extra={
        <Button
          onClick={async () => {
            await onLogout();
          }}
          type="primary"
        >
          Logout
        </Button>
      }
      status="500"
      subTitle={subTitle}
    />
  );
};

export default FetchUserError;
